import Styled, { css } from 'styled-components';

import { FONT_MAP } from '../../../../lib/StyledComponents/StyledComponents';
import { VALID_FONTS } from '../../../../lib/StyledComponents/Theme/common';
import {
  cssDeclaration,
  VALID_COLOR_DATA,
  VALID_EDGE_STYLE_DATA,
  VALID_MEDIA_STYLES,
} from '../../Utils';
import { VALID_TEXT_TRANSFORM } from '../common';

import { ITextCommonProps } from './common';

interface IStyledTextProps extends ITextCommonProps {
  colorProp?: VALID_COLOR_DATA;
  displayProp?: VALID_MEDIA_STYLES;
  fontType?: VALID_FONTS;
  marginProp?: VALID_EDGE_STYLE_DATA;
  orderProp?: VALID_MEDIA_STYLES;
  paddingProp?: VALID_EDGE_STYLE_DATA;
  textTransform?: VALID_TEXT_TRANSFORM;
  letterSpacing?: string;
}

export const StyledText = Styled.span<IStyledTextProps>`
  /*
    zeros global styles set by src/lib/StyledComponents/globalStyleCommon.ts
    this can be removed once the global css is restructured
  */
  margin: 0;
  line-height: inherit;
  font-size: inherit;

  ${props => {
    const themeTwo = props.theme.themeTwo;
    const {
      align,
      alignSelf,
      backgroundColor,
      colorProp,
      decoration,
      displayProp,
      flexBasis,
      flexGrow,
      flexShrink,
      fontStyle,
      fontType,
      letterSpacing,
      lineHeight,
      marginProp,
      orderProp,
      overflowWrap,
      paddingProp,
      round,
      size,
      textTransform,
      verticalAlign,
      weight,
    } = props;

    return css`
      font-family: ${fontType && FONT_MAP[fontType]};
      font-style: ${fontStyle};
      font-weight: ${weight};
      text-decoration: ${decoration};
      text-transform: ${textTransform};
      vertical-align: ${verticalAlign};
      letter-spacing: ${letterSpacing && themeTwo.global.edgeSize[letterSpacing] || letterSpacing};

      /* line-height */ ${lineHeight && cssDeclaration(themeTwo, 'line-height', lineHeight)};
      /* background-color */ ${backgroundColor && cssDeclaration(themeTwo, 'background-color', backgroundColor)};
      /* color */ ${colorProp && cssDeclaration(themeTwo, 'color', colorProp)};
      /* display */ ${displayProp && cssDeclaration(themeTwo, 'display', displayProp)};
      /* margin */ ${cssDeclaration(themeTwo, 'margin', marginProp)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', paddingProp)};
      /* border-radius */ ${round && cssDeclaration(themeTwo, 'border-radius', round)};
      /* font-size */ ${size && cssDeclaration(themeTwo, 'font-size', size)};
      /* text-align */${align && cssDeclaration(themeTwo, 'text-align', align)};
      /* overflow-wrap */${overflowWrap && cssDeclaration(themeTwo, 'overflow-wrap', overflowWrap)};

      // Flex child properties
      ${alignSelf && cssDeclaration(themeTwo, 'align-self', alignSelf)};
      ${flexBasis && cssDeclaration(themeTwo, 'flex-basis', flexBasis)};
      ${flexGrow && cssDeclaration(themeTwo, 'flex-grow', flexGrow)};
      ${flexShrink && cssDeclaration(themeTwo, 'flex-shrink', flexShrink)};
      ${orderProp && cssDeclaration(themeTwo, 'order', orderProp)};
    `;
  }}
`;
